import { PAGE_PATHS } from '../constants/pathsRoots';

export const getBreadCrumbs = (name, link = '', currentBreadCrumbs) => {
  currentBreadCrumbs = currentBreadCrumbs || [PAGE_PATHS[name]];
  return [...currentBreadCrumbs, { name, link }];
}



// WEBPACK FOOTER //
// src/utils/breadCrumbs.js